import ButtonLarge from 'common/ButtonLarge';
import CreateText from 'common/CreateText';
import styled from 'styled-components';

import React from 'react';

const ContainerDiv = styled.div`
    background: ${(props) => props.theme.colorBackground};
    width: 100%;
    height: 100%;
    min-height: 400px;
    flex: 1;
    margin-top: 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .button {
        padding: 0px 60px;
    }

    .text {
        margin: 22px 0px;
    }
`;

const EmptyOfficeLocations = ({ togglePopup }) => {
    return (
        <ContainerDiv>
            <div>
                <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
                    <path
                        d="M22 2C15.373 2 10 7.373 10 14c0 12 12 26 12 26s12-14 12-26c0-6.627-5.373-12-12-12zm0 17c-2.761 0-5-2.239-5-5s2.239-5 5-5 5 2.239 5 5-2.239 5-5 5z"
                        fill="#C4C4C4"
                    />
                </svg>
            </div>

            <CreateText className="text">
                Set up your Office Locations
            </CreateText>

            <div style={{ 
                textAlign: 'center', 
                maxWidth: '500px', 
                marginBottom: '32px',
                color: '#666',
                fontSize: '16px',
                lineHeight: '1.5',
                fontFamily: 'Poppins, sans-serif'
            }}>
                Add your business locations where patients can visit for appointments. 
                Include address details and contact information for each location. 
                For telemedicine or remote-only businesses, you can leave the address field blank.
            </div>

            <div>
                <ButtonLarge onClick={togglePopup} className="button">
                    Add a Location
                </ButtonLarge>
            </div>
        </ContainerDiv>
    );
};

export default EmptyOfficeLocations;
